export function deriveDisplayedChargingCycles(
  rawChargingCycles: unknown,
  numberOfChargingEvents: unknown,
): unknown {
  if (typeof rawChargingCycles !== 'number') {
    return rawChargingCycles;
  }

  if (
    typeof numberOfChargingEvents === 'number' &&
    rawChargingCycles > numberOfChargingEvents
  ) {
    return numberOfChargingEvents;
  }

  return rawChargingCycles;
}
